<script lang="ts" setup>
defineProps({
  power: {
    default: 'welcome',
    type: String as PropType<BasePowerPower>,
  },
  size: {
    default: 'sm',
    type: String as PropType<BasePowerSize>,
  },
})

const { t } = useI18n()
</script>

<template>
  <div
    class="pointer-events-none select-none"
    :class="{
      'h-16': size === '2xs',
      'h-20': size === 'xs',
      'h-24': size === 'sm',
      'h-32': size === 'md',
    }"
  >
    <img
      :alt="t('globals.power')"
      class="size-full"
      loading="lazy"
      :src="`/images/bases/BasePower/power-${power}.svg`"
    >
  </div>
</template>
